export interface ExportWinnerRow {
  phone: string;
  award: string;
  ranking?: number;
  status?: string;
  name?: string | null;
  email?: string | null;
  code?: string;
  reserve_for?: string | null;
}

const downloadBlob = (content: string, filename: string, mime: string): void => {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const escapeCsv = (value: string): string => {
  if (/[",\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

const cell = (value: string | number | null | undefined): string =>
  escapeCsv(value == null ? "" : String(value));

/** Admin export — puni redovi iz /api/admin/winners */
export const exportAdminWinnersCsv = (
  rows: ExportWinnerRow[],
  filename: string
): void => {
  const header = "Rang,Status,Ime,Telefon,Email,Kod,Nagrada,Rezerva za";
  const body = rows
    .map(
      (row) =>
        [
          cell(row.ranking),
          cell(row.status),
          cell(row.name),
          cell(row.phone),
          cell(row.email),
          cell(row.code),
          cell(row.award),
          cell(row.reserve_for),
        ].join(",")
    )
    .join("\n");
  downloadBlob(
    `\uFEFF${header}\n${body}`,
    filename,
    "text/csv;charset=utf-8;"
  );
};

export const exportAdminWinnersExcel = (
  rows: ExportWinnerRow[],
  filename: string
): void => {
  const tableRows = rows
    .map(
      (row) =>
        `<tr><td>${row.ranking ?? ""}</td><td>${row.status ?? ""}</td><td>${
          row.name ?? ""
        }</td><td>${row.phone}</td><td>${row.email ?? ""}</td><td>${
          row.code ?? ""
        }</td><td>${row.award}</td><td>${row.reserve_for ?? ""}</td></tr>`
    )
    .join("");

  const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
<head><meta charset="UTF-8"></head>
<body>
<table>
<tr><th>Rang</th><th>Status</th><th>Ime</th><th>Telefon</th><th>Email</th><th>Kod</th><th>Nagrada</th><th>Rezerva za</th></tr>
${tableRows}
</table>
</body>
</html>`;

  downloadBlob(html, filename, "application/vnd.ms-excel");
};

/** Javni sajt — stari format (telefon + nagrada) */
export const exportWinnersCsv = (
  rows: ExportWinnerRow[],
  filename: string
): void => {
  const header = "Red,Telefon,Nagrada";
  const body = rows
    .map(
      (row, index) =>
        `${index + 1},${escapeCsv(row.phone)},${escapeCsv(row.award)}`
    )
    .join("\n");
  downloadBlob(
    `\uFEFF${header}\n${body}`,
    filename,
    "text/csv;charset=utf-8;"
  );
};

export const exportWinnersExcel = (
  rows: ExportWinnerRow[],
  filename: string
): void => {
  const tableRows = rows
    .map(
      (row, index) =>
        `<tr><td>${index + 1}</td><td>${row.phone}</td><td>${row.award}</td></tr>`
    )
    .join("");

  const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
<head><meta charset="UTF-8"></head>
<body>
<table>
<tr><th>Red</th><th>Telefon</th><th>Nagrada</th></tr>
${tableRows}
</table>
</body>
</html>`;

  downloadBlob(html, filename, "application/vnd.ms-excel");
};
